enum GigServiceType {
  OnGoingMealPrep = "On going meal prep",
  PrivateChefOneTimeService = "Private chef one-time service",
  RetreatCateringMultipleDays = "Retreat catering, multiple days",
  WeddingCatering = "Wedding catering",
  CookingClassOrDemo = "Cooking class, or demo",
  VacationBookingMultipleDays = "Vacation booking, multiple days",
  PreOrPostNatalChefSupport = "Pre or post natal chef support",
  NoneOfThese = "None of these describes my gig, I’m unique!",
}

enum GigLocation {
  NearMyHome = "Near my home",
  AnotherLocation = "Another location",
  Online = "Online",
}

enum GigType {
  OngoingSupportMealPrepMealDelivery = "Ongoing support. meal prep, meal delivery",
  PrivateChefOneDayService = "Private chef one day service",
  WeddingCatering = "Wedding catering",
  CookingClass = "Cooking Class",
  ChefForMultiDayVacationBooking = "Chef for multi-day vacation booking",
  PreOrPostNatalSupport = "Pre or post natal support",
}

enum GigTags {
  HolisticNutrition = "Holistic Nutrition",
  Hawaiian = "Hawaiian",
  Indian = "Indian",
  Italian = "Italian",
  Japanese = "Japanese",
  Keto = "Keto",
  Macrobiotic = "Macrobiotic",
  Mexican = "Mexican",
  MedicalMedium = "Medical Medium",
  Mediterranean = "Mediterranean",
  MiddleEastern = "Middle Eastern",
  Morrocan = "Morrocan",
  NutritionConsulting = "Nutrition Consulting",
  Lebanese = "Lebanese",
  Picnics = "Picnics",
  PlantParadox = "Plant-Paradox",
  Natal = "Pre/post Natal",
  RawVegan = "Raw-vegan",
  Southern = "Southern",
  Thai = "Thai",
  TCM = "TCM",
  Turkish = "Turkish",
  Vegetarian = "Vegetarian",
  Vegan = "Vegan",
  Vietnamese = "Vietnamese",
  Whole30 = "Whole30",
  ZeroWaste = "Zero Waste",
}

enum ServiceStyle {
  SeatedMeal = "Seated Meal(s)",
  FamilyStyleMeal = "Family Style Meal(s)",
  BuffetMeal = "Buffet Meal(s)",
  DeliveredMeal = "Delivered Meal",
}

enum MealsDesired {
  Dinner = "Dinner",
  Lunch = "Lunch",
  Breakfast = "Breakfast/Brunch",
  Appetizers = "Appetizers",
}

enum AdditionalServices {
  UtensilsRental = "Rentals: linens, plates flatware, etc",
  Staff = "Servers and front of house staff",
  Beverage = "Beverage service",
  KitchenRental = "Kitchen rental",
}

const PublicDetailsConstants = {
  MinNumberOfGuests: 1,
  MaxNumberOfGuests: 500,
  MinTotalBudget: 5,
  MaxTotalBudget: 30_000,
} as const;

const PrivateGigConstants = {
  InviteLimit: 5,
} as const;

export {
  AdditionalServices,
  GigLocation,
  GigServiceType,
  GigTags,
  GigType,
  MealsDesired,
  PrivateGigConstants,
  PublicDetailsConstants,
  ServiceStyle,
};
